import * as React from "react";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import ShubhForm from "shubhform";
import {getValueForUserInput,
        inputFieldStyles,
        eligibilityScreenFields,
        getCustomizedRegexError,
        getCustomizedErrors} from "loan-application/utils";
import {diffYears} from "utils";
import ContainerBox from "myshubhlife-component/container-box";
import {COLOR, INPUT_TYPE} from "utils/variables";
import {sliceValueUptoMaxLength} from "userform/utils";
import {useEffect, useState} from "react";
import {getCompanyInfo} from "loan-application/apiCall";
import {IProfile} from "StateInterface";
import {handleNavigation, routePaths} from "loan-application/routes";
import {saveLamProfile} from "profile/api";
import Loading from "components/loading";
import { FIELD_NAMES } from "profile/enums";
import {AndroidApis} from "app";
import SearchInput from "myshubhlife-component/searchInput";
import {setLamProfile} from "profile/actions";
import {SelectField} from "web-com";

interface IConnectProps {
    dispatch?: (action: any) => void;
    profile: IProfile;
    userId: number;
    authExt: any;
    isAndroid: boolean;
}

enum EMPLOYMENT_TYPE {
    SELF_EMPLOYED = "SELF_EMPLOYED",
    SALARIED = "SALARIED",
}
enum SALARY_MODE {
    BANK_TRANSFER = "BANK_TRANSFER",
    CHEQUE = "CHEQUE",
    CASH = "CASH",
}
enum ERROR_TYPE {
    COMPANY = "company",
    OTP = "otp",
    WORK_EXP = "workExp",
}
enum ERROR_MESSAGE {
    OTP_FAILED = "Incorrect OTP",
    IF_COMPANY_EMPTY = "Please select the name of your company to continue the application",
}
let profileObj = null;
const PINCODE_LENGTH = 6;

const convertMonthToYearAndMonths = (totalMonths: number) => {
    const month = totalMonths % 12;
    const year = (totalMonths - month) / 12;
    return {month, year};
};
const EligibilityPage = (props: IConnectProps) => {
    const {utm_source, utm_campaign, utm_medium, emp_id, phone} = props.authExt;
    const [companyInfo, updateCompanyInfo] = useState([]);
    const [pincodeServiceability, setPincodeServiceability] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState({currentEmployer: "", workCin: ""});
    const [errors, setErrors] = useState({type: "", msg: ""});
    const [loading, setLoading] = useState(false);
    const [showSearchInput, setShowSearchInput] = useState(false);
    const [workExperience, setWorkExperience] = useState(
        convertMonthToYearAndMonths(props.profile?.workExperienceMonths || 0),
    );
    useEffect(() => {
        window.scrollTo(0, 0);
        if (props.isAndroid) {
            AndroidApis.toolBarConfig({visibility: true, title: "Basic Eligibility"});
        }
        if (props.authExt && props.authExt.currentEmployer || utm_source) {
            let currentEmployer = props.authExt.currentEmployer || utm_source;
            currentEmployer = currentEmployer.split("_").join(" ");
            getCompanyInfo(currentEmployer.replace("&", "%26")).then((res) => {
                res.data.hits.hit.map((item) => {
                    if (item.fields.name === currentEmployer) {
                        setSelectedCompany({
                            currentEmployer,
                            workCin: item.fields.cin,
                        });
                    }
                });
            });

        }
        if (props.profile && !props.authExt.hasOwnProperty(FIELD_NAMES.CURRENT_EMPLOYER)) {
            setSelectedCompany({
                currentEmployer: props.profile.currentEmployer,
                workCin: props.profile.workCin,
            });
        }
    }, [props.profile]);

    const updateLamProfile = (sourcingCode: string, profileToBeSend: IProfile, isNavigation: boolean) => {
        setLoading(true);
        props.dispatch(setLamProfile(profileToBeSend));
        saveLamProfile(props.userId, profileToBeSend, sourcingCode || utm_source, {
          source: utm_source,
          medium: utm_medium,
          campaign: utm_campaign,
        }).then((res) => {
          if (res.status === 200) {
            isNavigation ? handleNavigation(routePaths.PRODUCT) : setLoading(false);
          }
        }).catch((err) => {
          setLoading(false);
        });
    };

    const handleSubmit = (currentValues) => {
        const sourcingCode = props.authExt ? props.authExt.sourcingCode : null;
        const profileToBeSend = {
            ...props.profile,
            currentEmployer: selectedCompany.currentEmployer,
            workCin:  selectedCompany.workCin,
            financeBasicInfo: {
                ...props.profile.financeBasicInfo,
            },
            alternateAddresses: props.profile["alternateAddresses"] ? props.profile.alternateAddresses : [],
            workExperienceMonths: Number(workExperience.year) * 12 + Number(workExperience.month),
        };
        if (emp_id && profileToBeSend.employeeId !== emp_id) { profileToBeSend.employeeId = emp_id; }
        if (!workExperience.year && !workExperience.month) {
            setErrors({type: ERROR_TYPE.WORK_EXP, msg: "Please select work experience to continue"});
            return;
        } else if (!selectedCompany.currentEmployer || !selectedCompany.workCin) {
            setErrors({type: ERROR_TYPE.COMPANY, msg: ERROR_MESSAGE.IF_COMPANY_EMPTY});
            return;
        } else  {
            setErrors({type: "", msg: ""});
        }
        currentValues.forEach((field) => {
            if (field.name === FIELD_NAMES.EMPLOYMENT_TYPE ||
                field.name === FIELD_NAMES.SALARY_MODE ||
                field.name === FIELD_NAMES.NET_MONTHLY_INCOME) {
                profileToBeSend.financeBasicInfo[field.name] = getValueForUserInput(field.value, field.inputType);
            } else if (field.name === FIELD_NAMES.PINCODE) {
                const len = profileToBeSend.alternateAddresses.length;
                profileToBeSend.alternateAddresses =
                    [{...profileToBeSend.alternateAddresses[len - 1], pincode: field.value}];
            } else {
                profileToBeSend[field.name] = getValueForUserInput(field.value, field.inputType);
            }
        });
        if (JSON.stringify(profileToBeSend) === JSON.stringify(props.profile)) {
            return handleNavigation(routePaths.PRODUCT);
        }
        updateLamProfile(sourcingCode, profileToBeSend, true);
    };
    const handlePinCodeCheck = (result: boolean) => {
        setPincodeServiceability(result);
    };
    const onChangeHook = (fieldDetails) => {
        if (fieldDetails.name.includes(FIELD_NAMES.PINCODE)) {
            fieldDetails.value = sliceValueUptoMaxLength(fieldDetails.value,
                fieldDetails.max_length ? fieldDetails.max_length : PINCODE_LENGTH);
        }
        if (fieldDetails.name.includes(FIELD_NAMES.PINCODE) && fieldDetails.value.length === PINCODE_LENGTH) {
            // checkPincodeValidity(fieldDetails.value, handlePinCodeCheck);
            handlePinCodeCheck(true);
        }
        return fieldDetails;
    };
    const handleOnSelect = (name, value) => {
        setSelectedCompany({
            currentEmployer: name,
            workCin: value,
        });
        setShowSearchInput(false);
        setErrors({type: null, msg: null});
        updateCompanyInfo([]);
    };
    const handleCompanyButtonClick = () => {
        setShowSearchInput(true);
    };
    const onChangeHandler = (value) => {
        let updated = false;
        if (value.length >= 3) {
            getCompanyInfo(value.replace("&", "%26").replace("`", "%60")).then((res) => {
                updateCompanyInfo(res.data.hits.hit);
                res.data.hits.hit.map((item) => {
                    if (item.fields.name === value) {
                        setSelectedCompany({
                            currentEmployer: value,
                            workCin: item.fields.cin,
                        });
                        updated = true;
                    } else if (item.fields.name === value.trim()) {
                        setSelectedCompany({
                            currentEmployer: value.trim(),
                            workCin: item.fields.cin,
                        });
                        updated = true;
                    }
                });
            });
        }
        if (!updated) {
            setSelectedCompany({
                workCin: "",
                currentEmployer: value,
            });
        }
    };
    const renderEmployer = () => {
        const options = companyInfo.map((item) => {
            return {
                name: item.fields.name,
                value: item.fields.cin,
            };
        });
        return (
            <div className="company-search-container">
                <label className="label">Company name</label>
                <div className="select-name"
                     style={{color: COLOR.BLACK}}
                     onClick={handleCompanyButtonClick}
                >{
                    selectedCompany.currentEmployer ?
                    selectedCompany.currentEmployer :
                    "Please enter company name"
                    }
                </div>
                {
                    showSearchInput &&
                    <SearchInput onChange={onChangeHandler}
                                 isAndroid={props.isAndroid}
                                 onClose={() => setShowSearchInput(false)}
                                 onSelect={handleOnSelect}
                                 value={selectedCompany.currentEmployer}
                                 fieldName={"currentEmployer"}
                                 list={options}
                                 showSearchInput={showSearchInput}
                                 placeholder={"Type company name.."}
                                 label={"Please enter company name"}
                    />
                }
                <div className="error-message">
                    {errors.type === ERROR_TYPE.COMPANY ? errors.msg : null}
                </div>
            </div>
        );
    };
    const renderWorkExperienceInMonths = () => {
        return(
            <div className="work-experience-container">
                <label className="label pl-2">Total work experience</label>
                <div className="flex flex-col">
                    <SelectField
                        options={[
                            {name: "Select year", value: ""},
                            ...(Array.from(Array(61).keys()).map((item) => {
                                return {name : item, value: item};
                            })),
                        ]}
                        onChangeHandler={(name, val) => setWorkExperience((prev) => {
                            return {...prev, year: Number(val)};
                        })}
                        fieldName="year"
                        value={workExperience.year}
                        name="Year"
                        styleType="line"
                    />
                    <SelectField
                        options={[
                            {name: "Select month", value: ""},
                            ...(Array.from(Array(12).keys()).map((item) => {
                                return {name : item, value: item};
                            })),
                        ]}
                        onChangeHandler={(name, val) => setWorkExperience((prev) => {
                            return {...prev, month: Number(val)};
                        })}
                        fieldName="month"
                        name="Month"
                        value={workExperience.month}
                        styleType="line"
                    />
                </div>
                {
                    errors.type === ERROR_TYPE.WORK_EXP &&
                    <p className="text-danger pl-2 small m-0">{errors.msg}</p>
                }
            </div>
        );
    };

    const getFields = () => {
        if (props.authExt.currentEmployer === "DUNZO_DIGITAL_PRIVATE_LIMITED") {
            profileObj = props.profile && {
                ...props.profile,
                financeBasicInfo: {
                    ...props.profile.financeBasicInfo,
                    [FIELD_NAMES.EMPLOYMENT_TYPE] : EMPLOYMENT_TYPE.SELF_EMPLOYED,
                    [FIELD_NAMES.SALARY_MODE]: SALARY_MODE.BANK_TRANSFER,
                },
            };
            return eligibilityScreenFields(profileObj, {
                [FIELD_NAMES.EMPLOYMENT_TYPE]: true,
                [FIELD_NAMES.SALARY_MODE]: true,
            });
        }
        return eligibilityScreenFields(props.profile);
    };
    return (
        <ContainerBox
            backgroundColor={COLOR.WHITE}
            pageTitle={!props.isAndroid ? "Basic Eligibility" : ""}
            showBackButton={!props.isAndroid}
        >
            <Loading active={loading} msg={"We are checking your eligibility"}/>
            {<ShubhForm
                fields={getFields()}
                onSubmit={handleSubmit}
                onValidate={handleEligibilityValidation}
                customStyles={inputFieldStyles()}
                submitTitle="Continue"
                headerTitle="Please enter your details"
                onChangeHook={onChangeHook}
                additionalBottomField={<>
                    {renderWorkExperienceInMonths()}
                    {renderEmployer()}
                </>}
                isDatePicker={false}
            />}
        </ContainerBox>
    );
};

export const handleEligibilityValidation = (currentValues) => {
    let validation = {status: true, errors: null};
    for (const property of currentValues) {
        if (property.value && typeof property.value === "string") {
            property.value = (property.value).trim();
        }
        if (!property.value) {
            validation = {status: false, errors: {[property.name]: getCustomizedErrors(property)}};
            break;
        } else if (property.regex !== undefined && property.regex !== null &&
            !new RegExp(property.regex).test(property.value)) {
            validation = {
                status: false,
                errors: {[property.name]: getCustomizedRegexError(property)},
            };
            break;
        } else if (property.inputType === INPUT_TYPE.DATE &&
            (diffYears(new Date(), new Date(property.value)) < property.min ||
                diffYears(new Date(), new Date(property.value)) > property.max)
        ) {
            validation = {
                status: false,
                errors: {[property.name]: `Age should be between ${property.min} and ${property.max}`},
            };
            break;
        }
    }
    return validation;
};

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        userId: state.login.auth.userId,
        profile: state.profileInfo.profile,
        authExt: state.login.authExt,
        isAndroid: state.login.isAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(EligibilityPage);
